<template>
  <form @submit.prevent @keyup.enter.stop="searchSocio" action>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Deseja Arquivar o Sócio?</p>
      </header>

      <section class="modal-card-body">
        <div class>
          <div class="card" style="width: 320px; margin: 20px auto 0 auto">
            <header class="card-header">
              <p class="card-header-title" style="justify-content: center;">Informações do Sócio</p>
            </header>
            <div class="card-image" style="padding: 10px;">
              <div class="content">
                <p>
                  <strong>Nome:</strong>
                  {{socio.nome}}
                </p>
                <p>
                  <strong>Profissão:</strong>
                  {{socio.profissao_atual}}
                </p>
                <p>
                  <strong>Frequencia Reunião:</strong>
                  {{socio.associacoes[`${idAssociacao}`].frequencia.faltas}} Faltas
                </p>
                <p>
                  <strong>Pgto Mensalidades:</strong>
                  Pendente
                </p>
              </div>
            </div>
            <footer class="card-footer">
              <a href="#" @click="archiveSocio" class="card-footer-item button is-danger">Arquivar</a>
            </footer>
          </div>
        </div>
      </section>

      <footer class="modal-card-foot">
        <button class="btn-cancel button is-danger" @click="closeModal">Cancelar</button>
      </footer>
    </div>
  </form>
</template>

<script>
import FormAddSocios from "./FormAddSocios";

export default {
  props: ["socio"],
  data() {
    return {
      idAssociacao: this.$cookies.get("IDASSOCIACAO")
    };
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },

    // Busca o sócio no banco de dados
    async archiveSocio() {
      const loadingComponent = this.$loading.open({
        container: null
      });

      await this.$store.dispatch(
        "associacao/archivePartnerInFirestore",
        this.socio._id
      );
      loadingComponent.close();

      if (this.$store.getters["associacao/getIsSuccess"]) {
        this.$alert("Aviso!", "Sócio Arquivado!", "success");
        this.closeModal();
      } else {
        this.$alert("Aviso!", "Erro ao Arquivar Sócio!", "danger");
      }
    }
  },
  mounted() {
    // console.log(this.socio);
  }
};
</script>

<style scoped>
.button:not(.btn-cancel) {
  height: 2.6em !important;
}
.loading {
  text-align: center;
}
p {
  margin: 0 !important;
}
footer {
  text-align: right;
  display: block;
}
@media screen and (max-width: 1088px) {
  .modal .animation-content .modal-card {
    overflow: scroll !important;
  }
}
</style>
